import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubgroupTabsComponent } from './subgroup-tabs.component';
import { GroupTabComponent } from './group-tab.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
  imports: [
    CommonModule,
    BsDropdownModule.forRoot(),
  ],
  declarations: [SubgroupTabsComponent, GroupTabComponent],
  exports: [SubgroupTabsComponent],
})
export class SubgroupTabsModule { }
